module.exports = __webpack_public_path__ + "static/media/404.920388ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/404.svg
// module id = 723
// module chunks = 0